'use client'

import { Switch } from '@headlessui/react'
import clsx from 'clsx'
import React from 'react'

export default function Toggle({
  checked,
  onChange,
  className,
  ...props
}: React.ComponentProps<typeof Switch>) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      {...props}
      className={clsx(
        className,
        'focus:outline-hidden data-checked:bg-primary-600 focus:ring-primary-600 group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-offset-2',
      )}
    >
      <span
        aria-hidden="true"
        className="group-data-checked:translate-x-5 pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out"
      />
    </Switch>
  )
}
